import {useEffect, useState} from "react";
import {db} from "../db";
import md5 from "blueimp-md5";
import Logo from "../images/logo_light_grey.png";
import PromptSpin from "../images/prompts.lottie";

export default function PromptHistory(props) {
    const [historyPrompts, setHistoryPrompts] = useState([]);
    const [selectedPrompt, setSelectedPrompt] = useState(null);  
    const [loading, setLoading] = useState(false);  
    const [animations, setAnimations] = useState(false);
    
    const handlePromptClick = (index) => {
        setSelectedPrompt(historyPrompts[index]);
      };
    
      const handleCloseModal = () => {
        setSelectedPrompt(null);
      };

    const getPromptHistory = async () => {
        setLoading(true);
        await db.history.reverse().toArray((collection => {
            // const promptHistory = [];
            // collection.forEach(item => {
            //     const exists = promptHistory.findIndex((history) => {
            //         if (history.prompt) {
            //             if (history.prompt.prompt.prompt === item.prompt.prompt.prompt) {
            //                 return true;
            //             }
            //         }
            //         return false;
            //     }) !== -1;
            //     if (!exists) {
            //         console.log('history item does not exist');
            //         promptHistory.push(item);
            //     }
            // });
            setHistoryPrompts(collection);
        }));
        setLoading(false);
    }

    // console.log(db.history.reverse().toArray());

    useEffect(() => {
        db.settings.where("key").equals("enable_animations").first(setting => {
            setAnimations(setting.value)
        })
        getPromptHistory();
    }, []);

    return (     
    <>
    {loading ? 
        <>
        {animations ?
            <div className="w-2/3 mx-auto">
                <lottie-player
                autoplay
                loop
                mode="normal"
                src={PromptSpin}
                ></lottie-player>
            </div>
        :
            <img src={Logo} alt={"Promptus Logo"} className="w-2/3 mx-auto animate-pulse" />  
        }
    </>  
        : 
      <ul className={`w-full max-w-screen-lg bg-white p-5 text-dark-blue h-full max-h-screen overflow-auto ${selectedPrompt ? "hidden" : null}`}>
          {historyPrompts.map((historyPrompt, index) =>
            <div className="hover:bg-dark-blue/20 transition flex flex-row align-middle justify-between border-b-2">
                <li className={"p-2 cursor-pointer rounded flex flex-col"} key={`prompt_${historyPrompt.id}`} onClick={() => {
                    props.setPrompt(historyPrompt.prompt, true);
                    props.closeEvent();
                } }>
                    <div className={"text-sm"}>{historyPrompt.prompt}</div>
                    {/* <div className={"self-end"}>{(new Date(historyPrompt.timestamp)).toLocaleString('en-GB')}</div> */}
                </li>
                <button className={"p-2 self-end text-sm align-middle"} onClick={() => handlePromptClick(index)}>With Seeds</button>
            </div>
          )}
      </ul>
    }
        {selectedPrompt ? 
                <ul className={"w-full max-w-screen-lg bg-white p-5 text-dark-blue h-full max-h-screen overflow-auto z-50"}>
                    <div>
                        <h2 className="text-lg">{selectedPrompt.prompt}</h2>
                        <ul>
                            {selectedPrompt.seeds.map((seed, seedIndex) => (
                            <li className={"p-2 cursor-pointer rounded hover:bg-dark-blue/20 transition border-b-2"} key={seedIndex} onClick={() => {
                                props.setSeedWithPrompt(selectedPrompt.prompt, seed)
                                props.closeEvent();
                            }}>{seed}</li>
                            ))}
                        </ul>
                        <button className={"rounded w-60 p-2 bg-yellow text-dark-blue font-semibold shadow mt-5"} onClick={handleCloseModal}>Close</button>
                    </div>
                </ul>
            :
                null
        }
    </>
    );
}
